// src/utils/format.js

// Formats an ISO date string as:
// - "today at HH:MM"
// - "yesterday at HH:MM"
// - "DD-MM-YY, HH:MM"
export function formatDate(isoString, useRelative = false) {
  const d = new Date(isoString);
  const now = new Date();

  // Helper to pad two digits
  const two = n => String(n).padStart(2, '0');

  // Build time component
  const hh = two(d.getHours());
  const mm = two(d.getMinutes());
  const timePart = `${hh}:${mm}`;

  // Build full date component
  const dd = two(d.getDate());
  const mmth = two(d.getMonth() + 1);
  const yy = String(d.getFullYear()).slice(-2);
  const fullDate = `${dd}-${mmth}-${yy}, ${timePart}`;

  if (useRelative) {
    // Determine if same day or yesterday
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const yesterdayStart = new Date(todayStart);
    yesterdayStart.setDate(todayStart.getDate() - 1);

    if (d >= todayStart) {
      return `today at ${timePart}`;
    } else if (d >= yesterdayStart) {
      return `yesterday at ${timePart}`;
    }
  }

  return fullDate;
}

// Formats a consumption value (stored in litres) as m³ with 3 decimal places.
export function formatConsumption(value) {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return String(value);
  return `${(num / 1000).toFixed(3)} m³`;
}
